import React, { useEffect, useState } from "react";

import PretendardText from "../../atoms/text/pretendardText";
import MainInput from "../../atoms/input/mainInput";
import Popup from "../../molecules/popup";

import PopupOverLay from "../PopupOverlay";
import TableText from "../../atoms/text/table/tableText";
import moment from "moment";
import { toast } from "react-toastify";
import OrderApi from "../../../api/order.api";
import { errorHandler } from "../../../util/errorHandler";

const CancelRejectPopup = ({ setPopupOpen, sellData, getSellList }) => {
  const [detail, setDetail] = useState("");

  const rejectRequestFunc = async () => {
    try {
      if (detail === "") {
        return toast("거절 사유를 입력해주세요.");
      }

      const data = {
        cancelRejectReason: detail,
      };

      const response = (await OrderApi.updateCancelReject(sellData.id, data))
        .data.data;

      toast("취소 거절되었습니다.");
      setPopupOpen(false);
      getSellList();
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <PopupOverLay
        isOpen={true}
        onClick={() => {
          setPopupOpen(false);
        }}
      >
        <Popup
          headerTitle="취소 거절 관리"
          footerBtnText="확인"
          onClick={() => {
            setPopupOpen(false);
          }}
          footerBtnHandler={() => {
            rejectRequestFunc();
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginBottom: 32,
            }}
          >
            <table
              style={{
                width: "100%",
                borderSpacing: 0,
                borderCollapse: "collapse",
              }}
            >
              <colgroup>
                {/* 합계: 630px */}
                {/* 구매번호 */}
                <col width="162px" />
                {/* 상품명 */}
                <col width="272px" />
                {/* 상태*/}
                <col width="76px" />
                {/* 취소 요청일 */}
                <col width="120px" />
              </colgroup>
              <thead>
                <tr
                  style={{
                    height: 41,
                    borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                  }}
                >
                  <th
                    style={{
                      paddingLeft: 30,
                    }}
                  >
                    <TableText
                      style={{
                        fontWeight: "600",
                        lineHeight: "22.75px",
                      }}
                    >
                      구매번호
                    </TableText>
                  </th>
                  <th>
                    <TableText
                      style={{
                        fontWeight: "600",
                        lineHeight: "22.75px",
                      }}
                    >
                      상품명
                    </TableText>
                  </th>
                  <th>
                    <TableText
                      style={{
                        fontWeight: "600",
                        lineHeight: "22.75px",
                      }}
                    >
                      상태
                    </TableText>
                  </th>
                  <th>
                    <TableText
                      style={{
                        fontWeight: "600",
                        lineHeight: "22.75px",
                      }}
                    >
                      취소 요청일
                    </TableText>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  style={{
                    height: 46,
                  }}
                >
                  <td>
                    <TableText
                      style={{
                        paddingLeft: 30,
                      }}
                    >
                      {sellData.payNumber}
                    </TableText>
                  </td>
                  <td>
                    <TableText>{sellData.orderTitle}</TableText>
                  </td>
                  <td>
                    <TableText>
                      {sellData.orderStatus === "PAY_COMPLETE"
                        ? "결제 완료"
                        : sellData.orderStatus === "CANCEL_REQUEST"
                        ? "취소 요청"
                        : sellData.orderStatus === "CANCEL_REJECT"
                        ? "취소 거절"
                        : sellData.orderStatus === "CANCEL_COMPLETE"
                        ? "취소 완료"
                        : ""}
                    </TableText>
                  </td>
                  <td>
                    <TableText>
                      {moment(sellData.cancelRequestDate).format("YYYY-MM-DD")}
                    </TableText>
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "0px 30px",
                marginTop: 20,
                gap: 12,
              }}
            >
              <PretendardText
                style={{
                  fontWeight: 500,
                  fontSize: 15,
                  lineHeight: "21.5px",
                  color: "#aaa",
                }}
              >
                거절 사유
              </PretendardText>
              <MainInput
                type={"text"}
                placeholder={"내용을 입력해 주세요."}
                style={{
                  width: "572px",
                }}
                value={detail}
                onChange={(e) => {
                  setDetail(e.target.value);
                }}
              />
            </div>
          </div>
        </Popup>
      </PopupOverLay>
    </>
  );
};

export default CancelRejectPopup;
